import Keycloak from "keycloak-js";

// `VITE_KEYCLOAK_URL` is baked in at build time, so a single image can't switch
// Keycloak hosts per request. Instead we resolve the host at *runtime* from the
// browser's current location: local access (localhost:3000) talks to the local
// Keycloak, public access (the deployed domain) talks to the public one. This
// requires the Keycloak client to whitelist both origins (it does — see
// infra/keycloak/airproc-realm.json) and Keycloak to answer on both hostnames
// (KC_HOSTNAME_URL must NOT be pinned to a single host).
function resolveKeycloakUrl(): string {
  const host = window.location.hostname;
  const isLocal =
    host === "localhost" || host === "127.0.0.1" || host === "[::1]";
  if (isLocal) {
    return import.meta.env.VITE_KEYCLOAK_URL_LOCAL ?? "http://localhost:8080";
  }
  return import.meta.env.VITE_KEYCLOAK_URL ?? "https://auth.altitude-ai.space";
}

const keycloak = new Keycloak({
  url: resolveKeycloakUrl(),
  realm: import.meta.env.VITE_KEYCLOAK_REALM ?? "airproc",
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT ?? "airproc-web",
});

export default keycloak;
